import { Popover as BasePopover } from '@base-ui/react/popover'

import { cn } from '@gto/ui/cn'

export const Positioner = (props: BasePopover.Positioner.Props) => {
  return (
    <BasePopover.Positioner
      sideOffset={4}
      {...props}
      className={cn('z-popover', props.className)}
    />
  )
}
